import { AddonPageOptions, BasketPageOptions, StorePageOptions } from 'types'

export const baseStorePageOptions: StorePageOptions = {
  introText: `Choose Plan`,
  hidePrice: true,
}

export const baseBasketPageOptions: BasketPageOptions = {
  introText: `Based on the details you have given us, below is your personalised insurance quote:`,
}

export const baseAddonPageOptions: AddonPageOptions = {}
